import { Component } from 'react';
import { AlertTriangle } from 'lucide-react';
import { BORDER_COLOR } from '../../styles/tokens';

/**
 * V65 — Frontera de error para una sección de pantalla.
 *
 * POR QUÉ EXISTE: `AdminPtoStats` leía un contrato que el backend dejó de servir en V60
 * (`counts.pending` sobre `undefined`), y eso no rompía la tarjeta ni la pestaña: dejaba
 * la ruta /admin ENTERA en blanco. Una excepción de render en React desmonta el árbol hasta
 * la raíz si nadie la atrapa, así que un componente secundario roto se lleva puesta toda
 * la aplicación — y el síntoma que ve el usuario ("la página está en blanco") no señala
 * en absoluto al componente culpable.
 *
 * ⚠ TIENE QUE SER UNA CLASE. Es la única API de React que atrapa errores de render;
 * no hay equivalente en hooks. No es código legacy.
 *
 * ⚠ ESTO NO REEMPLAZA ARREGLAR EL BUG, y no debe volverse el lugar donde los errores van
 * a morir en silencio: registra en consola con el nombre de la sección para que siga
 * siendo diagnosticable, y muestra QUÉ sección falló. Degradar ≠ ocultar.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error(`[ErrorBoundary] "${this.props.seccion || 'sección'}" falló:`, error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div style={{
        border: `1px solid #fecaca`, background: '#fef2f2', borderRadius: 12,
        padding: '16px 18px', margin: '12px 0', color: '#991b1b',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 700, fontSize: 13 }}>
          <AlertTriangle size={16} />
          No se pudo mostrar {this.props.seccion ? `«${this.props.seccion}»` : 'esta sección'}
        </div>
        <div style={{ fontSize: 12, marginTop: 6, lineHeight: 1.5, color: '#7f1d1d' }}>
          El resto de la pantalla sigue funcionando. El detalle está en la consola del navegador.
        </div>
        <details style={{ marginTop: 8 }}>
          <summary style={{ fontSize: 11, cursor: 'pointer', color: '#b91c1c' }}>Ver el error</summary>
          <pre style={{
            fontSize: 10, marginTop: 6, padding: 8, overflowX: 'auto',
            background: '#fff', border: `1px solid ${BORDER_COLOR}`, borderRadius: 6,
          }}>{String(this.state.error?.message || this.state.error)}</pre>
        </details>
      </div>
    );
  }
}
